<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align: center">
<img alt="Cover Everland by Rebecca Hunt " src="Images/Cover.jpg" style="height: 99%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copertina.vue?3b8680d7